import React, { RefObject } from 'react';
import { Dialog, Popover } from 'react-aria-components';
import cn from '@/utils/cn';
import { locale } from 'i18n-js';
import GlossaryTerm from '@/types/api/GlossaryTerm';

type GlossaryTermDefinitionProps = {
  glossaryTerm: GlossaryTerm;
  showDefinition: boolean;
  setShowDefinition: (show: boolean) => void;
  buttonRef: RefObject<HTMLDivElement>
};

const GlossaryTermDefinition = ({
  glossaryTerm,
  showDefinition,
  setShowDefinition,
  buttonRef }: GlossaryTermDefinitionProps) => {
  const term = locale === 'en' ? glossaryTerm.term : glossaryTerm.term_es;
  const definition = locale === 'en' ? glossaryTerm.definition : glossaryTerm.definition_es;

  if (!glossaryTerm.glossary_image_file_name) {
    return (
      <span className={cn('glossary-definition', { 'tw-hidden': !showDefinition })}>
        &nbsp;[{term} : {definition}]
      </span>
    );
  }

  return (
    <Popover
      isOpen={showDefinition}
      placement="bottom"
      triggerRef={buttonRef}
      onOpenChange={setShowDefinition}
    >
      <Dialog
        className={cn('tw-w-[240px] tw-max-h-[600px] tw-border tw-border-solid !tw-border-med-grey tw-bg-white',
          'tw-rounded-xl tw-overflow-hidden tw-outline-none')}
      >
        <div className={cn('tw-flex tw-justify-center tw-items-center tw-h-[3rem]  tw-my-auto tw-text-[1.25rem]',
          'tw-bg-[#247f99] tw-text-white tw-font-bold')}
        >
          {term}
          <button
            className={cn('tw-absolute tw-top-2 tw-right-2 tw-bg-transparent tw-text-white tw-border-none',
              'focus:tw-outline-none tw-cursor-pointer tw-text-[1.25rem]')}
            type="button"
            onClick={() => setShowDefinition(false)}
          >
            x
          </button>
        </div>
        <div className={cn('tw-text-[18px] tw-px-[1.25rem] tw-pb-[0.25rem]')}>
          <img alt={term} className="tw-w-[200px] tw-h-[200px]" src={glossaryTerm.s3_url} />
          <p className="tw-my-2"> {definition} </p>
        </div>
      </Dialog>
    </Popover>

  );
};

export default GlossaryTermDefinition;
